import React, {useState} from "react";
import PropTypes from "prop-types";

function Clipboard(props) {
  const {label, text, className} = props;
  const [status, setStatus] = useState(label);
  const [unsupport, setUnsupport] = useState(false);
  return unsupport ? (
    <a className={className} href={text}>
      {text}
    </a>
  ) : (
    <button
      className={className}
      onClick={() => {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(text)
            .then(() => {
              setStatus(`Ссылка в буфере обмена`);
              setTimeout(setStatus, 3000, label);
            })
            .catch(() => {
              setStatus(`Ошибка при копировании`);
              setTimeout(setStatus, 3000, label);
            });
        } else {
          setStatus(`${text}`);
          setUnsupport(true);
        }
      }}
    >
      {status}
    </button>
  );
}

Clipboard.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  text: PropTypes.string
};

export default Clipboard;
